import { render, staticRenderFns } from "./GiftPurchase.vue?vue&type=template&id=65744a54&scoped=true&lang=pug&"
import script from "./GiftPurchase.vue?vue&type=script&lang=js&"
export * from "./GiftPurchase.vue?vue&type=script&lang=js&"
import style0 from "./GiftPurchase.vue?vue&type=style&index=0&id=65744a54&lang=scss&scoped=true&"
import style1 from "./GiftPurchase.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65744a54",
  null
  
)

export default component.exports